export default __webpack_public_path__ + "static/media/certificate_four.7d5f3f0e.jpg";